export default "__VITE_ASSET__BOeV4TeV__"